<template>
  <div>
    <ul v-if="!$root.hideNavigation" :class="['vue-nav']">
      <template v-for="(mItem, menuIndex) in menu">
        <li :class="mItem.route && $route.name==mItem.route.name ? ['current'] : ''">
          <router-link :to="mItem.route ? mItem.route : {name: $route.name, params: $route.params}"
                       v-text="(menuIndex+1) + '. ' + mItem.text"></router-link>
        </li>
      </template>
    </ul>
    <!--
    <a v-if="$root.isGuestPage()" class="naf-logo" href="/naf-medlemmer-supre-fordeler-hos-mps-micropaint/"><img src="/wp-content/plugins/autotaksering/requests/assets/img/naf-logo.png"/> Medlemsfordel</a>
    -->
    <div class="vue-rqf bg-loading" :loading="$root.ui.loading">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

let guestMenu = [
  {
    route: {name: 'start'},
    text: 'Registrer bil',
    //href: this.$router.resolve({ name: 'start'}).href
  },
  {
    route: {name: 'damage-item', params: {id: 1}},
    text: 'Bilde av skaden',
    //href: this.$router.resolve({ name: 'damage-item', params: {id: 1}}).href
  },
  // {
  //   route: {name: 'additionals'},
  //   text: 'Andre skader',
  //   //href: this.$router.resolve({ name: 'contact'}).href
  // },
  {
    route: {name: 'contact'},
    text: 'Legg til kontaktinfo',
    //href: this.$router.resolve({ name: 'contact'}).href
  }
]
let adminMenu = [
  {
    route: {name: 'contact'},
    text: 'Register kunde',
    //href: this.$router.resolve({ name: 'contact'}).href
  },
  {
    route: {name: 'damage-item', params: {id: 1}},
    text: 'Register skade',
    //href: this.$router.resolve({ name: 'damage-item', params: {id: 1}}).href
  },
  // {
  //   route: {name: 'additionals'},
  //   text: 'Andre skader',
  //   //href: this.$router.resolve({ name: 'contact'}).href
  // },
  {
    //route: { name: 'damage-item', params: {id: 1}},
    text: 'Gi tilbud',
    //href: this.$router.resolve({ name: 'damage-item', params: {id: 1}}).href
  }
]

export default {
  data() {
    let res = {};
    if (this.$root.isAdminPage())
      res.menu = adminMenu
    else
      res.menu = guestMenu
    return res;
  },
  created: function () {
    if (this.$route.params.license) {
      this.$store.commit('setItem', {type: 'request', item: 'car_id', val: this.$route.params.license})
      this.$root.getCarModel();
    }
  }
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// Index.vue?c8e6e0b8